import "./Toast.css";

function Toast({ show, message }) {

  if (!show) return null;

  return (

    <div className="toast">

      <span className="toast-icon">
        ✔
      </span>

      <span className="toast-message">
        {message}
      </span>

    </div>

  );

}

export default Toast;